import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../modal/Modal";
import { CloseButton } from "../input/CloseButton";
import { TextInputField } from "../input/TextInputField";
import { useForm } from "react-hook-form";
import { Button } from "../input/Button";
import { FormattedMessage } from "react-intl";
import { Column } from "../layout/Column";

export function ObjectHrefModal({ onSubmit, onClose, activeObjectHref }) {
  const { isSubmitting, handleSubmit, register, errors } = useForm({
    defaultValues: {
      href: activeObjectHref
    }
  });

  return (
    <Modal
      title={<FormattedMessage id="object-href-modal.title" defaultMessage="Object Href" />}
      beforeTitle={<CloseButton onClick={onClose} />}
    >
      <Column as="form" padding center onSubmit={handleSubmit(onSubmit)}>
        <TextInputField
          name="href"
          placeholder="https://example.com/"
          type="url"
          ref={register}
          error={errors.href && errors.href.message}
        />
        <Button type="submit" preset="accept" disabled={isSubmitting}>
          <FormattedMessage id="object-href-modal.change-object-href-button" defaultMessage="Change Object Href" />
        </Button>
      </Column>
    </Modal>
  );
}

ObjectHrefModal.propTypes = {
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
};
